import { ReactElement, useState } from 'react';
import { ActionsContainer, ButtonWithMargin, ResultImage } from './styles';
import { DeleteIcon, ZoomInIcon } from '@root/src/assets/images';
import Lang from '@lang/en';

interface PropsI {
  imageUrl: string;
  clearImageUrl: () => void;
  setIsPreviewModalOpened: (value: boolean) => void;
  testId?: string;
}

const ResultMobileImage = ({
  imageUrl,
  clearImageUrl,
  setIsPreviewModalOpened,
  testId,
}: PropsI): ReactElement => {
  const [resultsKey, setResultsKey] = useState(1);

  const openPreviewModal = () => setIsPreviewModalOpened(true);
  const handleRemoveUpload = () => {
    clearImageUrl();
    setResultsKey(resultsKey + 1);
  };

  return (
    <>
      <ResultImage src={imageUrl} alt="result" data-testid={testId} />
      <ActionsContainer isMobile>
        <ButtonWithMargin
          isMobile
          icon={<ZoomInIcon />}
          type="tertiary"
          label={Lang.previewText}
          onClick={openPreviewModal}
        />
        <ButtonWithMargin
          isMobile
          icon={<DeleteIcon />}
          type="danger"
          label={Lang.deleteText}
          onClick={handleRemoveUpload}
        />
      </ActionsContainer>
    </>
  );
};

export default ResultMobileImage;
